<template>
  <div style="display:inline-block;width: 100%">
    <el-select
      v-if="status==='select'"
      v-model="regulatorId"
      style="width: 100%"
      placeholder="请选择监管机构"
      clearable
      @change="handleChange">
      <el-option
        v-for="item in regulators"
        :key="item.regulatorId"
        :label="item.regulatorName"
        :value="item.regulatorId">
      </el-option>
    </el-select>
    <span v-else>{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: 'VendorRegulatorSelect',
  components: {},
  props: {
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object
    },
    status: {
      type: String,
      default: 'select'
    }
  },
  data() {
    return {
      regulators: []
    }
  },
  computed: {
    regulatorId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    name() {
      const names = this.regulators.filter(o => this.value === o.regulatorId)
      return names.map(o => o.regulatorName).join('，')
    }
  },
  watch: {
    'option.vendorId': {
      handler(val, oldVal) {
        if (val && val !== oldVal) {
          this.fetchList()
        }
      },
      immediate: true
    }
  },
  methods: {
    handleChange(v) {
      console.log(v)
      const ret = this.regulators.find(el => el.regulatorId === v) || {}
      this.callback && this.callback(ret.inspectReportAudit)
    },
    fetchList() {
      this.$store.dispatch('vendor/getvendorregulators', {
        payload: this.option,
        success: (res) => {
          this.regulators = res.data.regulators
        },
        fail: () => {
          this.regulators = []
        }
      })
    }
  }
}
</script>
